<template>
  <a
    v-if="isLink && isExternalLink"
    :href="to"
    target="_blank"
    rel="noopener noreferrer"
    class="button"
    :class="[buttonClass, classes]"
  >
    {{ title }}
  </a>
  <RouterLink
    v-else-if="isLink"
    :to="to"
    class="button"
    :class="[buttonClass, classes]"
  >
    {{ title }}
  </RouterLink>
  <button
    v-else
    class="button"
    :class="[buttonClass, classes]"
    type="button"
    :disabled="isDisabled"
    @click="$emit('action')"
  >
    {{ title }}
  </button>
</template>

<script>
export default {
  name: "Button",
  props: {
    isLink: {
      type: Boolean,
      default: false,
    },
    to: {
      type: [Object, String],
      default: () => ({}),
    },
    title: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "primary",
      validator: (value) => ["primary", "secondary", "danger"].includes(value),
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    classes: {
      type: String,
      default: "",
    },
  },
  computed: {
    buttonClass() {
      return `${this.type}-button`;
    },
    isExternalLink() {
      return typeof this.to === "string" && /^(https?:|mailto:|tel:)/i.test(this.to);
    },
  },
};
</script>
